import * as z from "zod";
import { InlineLockAttrsSchema } from "./lock-types-schema";

/**
 * Tool node - references a tool that can be invoked.
 * Similar structure to variable but semantically different.
 */
const ToolNodeSchema_ = z.object({
  type: z.literal("tool"),
  instanceId: z.string(),
  selectionKey: z.string(),
  selectionLabel: z.string(),
  itemKey: z.string().optional(),
  itemLabel: z.string().optional(),
  config: z.record(z.string(), z.unknown()).optional(),
  lock: InlineLockAttrsSchema.optional(),
});

/** Base type from schema inference (no index signature) */
type ToolNodeBase = z.infer<typeof ToolNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type ToolNode = ToolNodeBase & { [key: string]: unknown };

/** Attrs type for tiptap (Omit done on base type before index signature) */
export type ToolNodeAttrs = Omit<ToolNodeBase, "type">;

export const ToolNodeSchema: z.ZodType<ToolNode> = ToolNodeSchema_;

/**
 * Type guard for tool nodes.
 */
export function isToolNode(node: unknown): node is ToolNode {
  return (
    typeof node === "object" &&
    node !== null &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    (node as Record<string, unknown>).type === "tool"
  );
}
